export var resolveSubfieldRepeatability = function (catalog, fieldTag, subfield) {
    var _a, _b, _c;
    if (subfield.formOnly)
        return { kind: 'notApplicable' };
    if (!catalog)
        return { kind: 'catalogUnavailable' };
    var catalogSubfield = (_c = (_b = (_a = catalog.fields) === null || _a === void 0 ? void 0 : _a[fieldTag]) === null || _b === void 0 ? void 0 : _b.subfields) === null || _c === void 0 ? void 0 : _c.find(function (s) { return s.code === subfield.code; });
    if (!catalogSubfield)
        return { kind: 'unknownSubfield' };
    if (!catalogSubfield.repeatable_default) {
        // Keep legacy invalid values visible and clearable. FormConfigValidator blocks
        // saving until repeatable:true is removed from a non-repeatable subfield.
        return subfield.repeatable === true ? { kind: 'illegalWidening' } : { kind: 'locked' };
    }
    return subfield.repeatable === false ? { kind: 'legacyNarrowing' } : { kind: 'ontologyRepeatable' };
};
export var isRepeatabilityEditable = function (state) {
    return state.kind === 'illegalWidening';
};
export var isRepeatabilityChecked = function (state) {
    return state.kind === 'illegalWidening' || state.kind === 'ontologyRepeatable' || state.kind === 'legacyNarrowing';
};
/** Clearing a legacy illegal widening deletes the key instead of writing false. */
export var repeatabilityPatch = function () { return ({ repeatable: undefined }); };
export var REPEATABLE_HINT_MESSAGE_IDS = {
    catalogUnavailable: 'ui-czna-authorities.settings.forms.visual.property.subfieldRepeatable.catalogUnavailable',
    unknownSubfield: 'ui-czna-authorities.settings.forms.visual.property.subfieldRepeatable.unknownSubfield',
    locked: 'ui-czna-authorities.settings.forms.visual.property.subfieldRepeatable.locked',
    ontologyRepeatable: 'ui-czna-authorities.settings.forms.visual.property.subfieldRepeatable.ontologyRepeatable',
    legacyNarrowing: 'ui-czna-authorities.settings.forms.visual.property.subfieldRepeatable.legacyNarrowing',
};
export var repeatabilityHintMessageId = function (state) {
    if (state.kind === 'illegalWidening' || state.kind === 'notApplicable')
        return null;
    return REPEATABLE_HINT_MESSAGE_IDS[state.kind];
};
export var ILLEGAL_WIDENING_MESSAGE_ID = 'ui-czna-authorities.settings.forms.visual.property.subfieldRepeatable.illegalWidening';
